<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Templates de Ordem de Serviço</h1>
        <p class="text-sm text-gray-500">Gerencie templates reutilizáveis para criação de ordens de serviço</p>
      </div>
      <button (click)="createNew()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Novo Template
      </button>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="templates" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Nome</th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Itens Checklist</th>
            <th class="text-left px-6 py-3">Campos Personalizados</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-template let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-semibold text-gray-900">{{ template.name }}</td>
            <td class="px-6 py-2 text-gray-600">{{ template.description || '-' }}</td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                {{ getChecklistItemsCount(template) }} itens
              </span>
            </td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">
                {{ getCustomFieldsCount(template) }} campos
              </span>
            </td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 rounded-full text-xs font-bold" [ngClass]="{
                'bg-green-100 text-green-800': template.active,
                'bg-gray-100 text-gray-800': !template.active
              }">
                {{ template.active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Editar"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(template.id!)">
                </p-button>
                <p-button
                  [pTooltip]="template.active ? 'Desativar' : 'Ativar'"
                  [icon]="template.active ? 'pi pi-eye-slash' : 'pi pi-eye'"
                  text
                  [severity]="template.active ? 'secondary' : 'success'"
                  (click)="toggleActive(template)">
                </p-button>
                <p-button
                  pTooltip="Excluir"
                  icon="pi pi-trash"
                  text
                  severity="danger"
                  (click)="delete(template.id!)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum template encontrado. Clique em "Novo Template" para criar um.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>

